var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-page-table"},[(_vm.heading && !_vm.isEmptyJsonRteField(_vm.heading.json))?_c('JsonRteField',{attrs:{"node":_vm.heading.json}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.table)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }